import { TFunction } from 'i18next'

export const addSwapFreePostfix = (
  isSwapFreeTA: boolean,
  accountType: string | null,
  t: TFunction
) => {
  return isSwapFreeTA ? `${accountType} ${t('Trading Account.swap-free')}` : accountType
}
